/**
 * Static feature flag bundle.
 *
 * The JSON is generated by the Django management command
 * `python manage.py generate_static_flags`. It maps flag-name -> default bool.
 *
 * Static flags are evaluated client-side from this bundle and are NOT
 * returned by the /api/orgs/{org_id}/feature-flags/ endpoint. See
 * apps/orgs/static_flags.py for the categorization rules.
 */
import staticFlagsRaw from './staticFlags.json';

const STATIC_FLAGS: Readonly<Record<string, boolean>> =
  staticFlagsRaw as Record<string, boolean>;

export function isStaticFlag(flagName: string): boolean {
  return Object.prototype.hasOwnProperty.call(STATIC_FLAGS, flagName);
}

export function getStaticFlagValue(flagName: string): boolean {
  return STATIC_FLAGS[flagName] ?? false;
}
